import { render, staticRenderFns } from "./verify-bank-info.vue?vue&type=template&id=d25be66e&scoped=true&"
import script from "./verify-bank-info.vue?vue&type=script&lang=js&"
export * from "./verify-bank-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25be66e",
  null
  
)

export default component.exports